__turbopack_context__.v({
  "black-bt": "sizeGuide-module-scss-module__ESjxbG__black-bt",
  "breadcrumb": "sizeGuide-module-scss-module__ESjxbG__breadcrumb",
  "btnCustom": "sizeGuide-module-scss-module__ESjxbG__btnCustom",
  "chart": "sizeGuide-module-scss-module__ESjxbG__chart",
  "formData": "sizeGuide-module-scss-module__ESjxbG__formData",
  "formGroup": "sizeGuide-module-scss-module__ESjxbG__formGroup",
  "heading": "sizeGuide-module-scss-module__ESjxbG__heading",
  "marginTop": "sizeGuide-module-scss-module__ESjxbG__marginTop",
  "note": "sizeGuide-module-scss-module__ESjxbG__note",
  "oh": "sizeGuide-module-scss-module__ESjxbG__oh",
  "pageTitle": "sizeGuide-module-scss-module__ESjxbG__pageTitle",
  "relative": "sizeGuide-module-scss-module__ESjxbG__relative",
  "top_0": "sizeGuide-module-scss-module__ESjxbG__top_0",
});
